@if (visible()) {
<div class="no-messages-banner" role="alert">
    <i class="pi pi-exclamation-triangle banner-icon"></i>
    <div class="banner-body">
        <p class="banner-text"><b>{{ reason() }}</b> {{ extra() }}</p>
        <p class="banner-text">Soporte de AdminAI: {{ supportDisplay }}</p>
    </div>
    <a [href]="supportLink" target="_blank" rel="noopener" class="banner-action">Escribir a Soporte</a>
</div>
}
